// extracted by mini-css-extract-plugin
export default {"userName":"UserAvatar_userName__MIHbK"};